import { useTranslations } from 'next-intl';

import Link from '@commons/components/Link';
import Flex from '@commons/containers/Flex';

/**
 * GardaWorld Footer LogoMenuDesktop component.
 */

const LogoMenuDesktop = () => {
  const t = useTranslations('footer');

  return (
    <>
      <Flex.Item border="left" paddingLeft="sm">
        <Link href={t('aboutUs.url')} reverse>
          {t('aboutUs.label')}
        </Link>
      </Flex.Item>
      <Flex.Item border="left" paddingLeft="sm">
        <Link href={t('mediaInquiries.url')} reverse>
          {t('mediaInquiries.label')}
        </Link>
      </Flex.Item>
    </>
  );
};

export default LogoMenuDesktop;
